export const DISCIPLES_AGE_CHILDREN = "DISCIPLES_AGE_CHILDREN"
export const DISCIPLES_AGE_ADULTS = "DISCIPLES_AGE_ADULTS"

export const DISCIPLE_AGE_OPTIONS = {
  [DISCIPLES_AGE_CHILDREN]: "для детей",
  [DISCIPLES_AGE_ADULTS]: "для взрослых",
}
